import {
  Button,
  Col,
  DatePicker,
  Input,
  Pagination,
  Popover,
  Row, Skeleton, Table
} from "antd";
import { useEffect, useState } from "react";
import { FaEye, FaSearch } from "react-icons/fa";
import { MdTune } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Get } from "../../config/api/get";
import { FEEDBACK } from "../../config/constants/api";
import moment from "moment";
import { useDebouncedCallback } from "use-debounce";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

const FeedbackManagement = () => {
  dayjs.extend(timezone);
  dayjs.extend(utc);
  const token = useSelector((state) => state.user.userToken);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [feedbacks, setFeedbacks] = useState(null);

  const [filter, setFilter] = useState({
    status: null,
    type: null,
    keyword: "",
    from: null,
    to: null,
  });
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const getUsers = (pageNumber, pageSize, from, to, keyword) => {
    setLoading(true);
    Get(FEEDBACK.getFeedbacks, token, {
      from,
      to,
      keyword,
      page: pageNumber
        ? pageNumber.toString()
        : paginationConfig.pageNumber.toString(),
      limit: pageSize ? pageSize.toString() : paginationConfig.limit.toString(),
    })
      .then((response) => {
        if (response?.data?.docs) {
          setFeedbacks(response?.data?.docs);
          setPaginationConfig({
            pageNumber: response?.data?.page,
            limit: response?.data?.limit,
            totalDocs: response?.data?.totalDocs,
            totalPages: response?.data?.totalPages,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error Fetching Loads", err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getUsers();
    // eslint-disable-next-line
  }, []);
  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = feedbacks
    ? `Showing records ${endIndex} of ${paginationConfig.totalDocs}`
    : "Showing records 0 of 0";
  // const feedbacks = [
  //   {
  //     key: "1",
  //     name: "John Doe",
  //     email: "john.doe@example.com",
  //     datePosted: "2023-04-15",
  //     subject: "Service Feedback",
  //     userType: "Customer",
  //     _id: 1,
  //   },
  //   {
  //     key: "2",
  //     name: "Jane Smith",
  //     email: "jane.smith@example.com",
  //     datePosted: "2023-04-18",
  //     subject: "Driver Feedback",
  //     userType: "Driver",
  //     _id: 2,
  //   },
  //   {
  //     key: "3",
  //     name: "Alice Johnson",
  //     email: "alice.johnson@example.com",
  //     datePosted: "2023-04-20",
  //     subject: "App Feedback",
  //     userType: "Customer",
  //     _id: 3,
  //   },
  //   {
  //     key: "4",
  //     name: "Bob Brown",
  //     email: "bob.brown@example.com",
  //     datePosted: "2023-04-22",
  //     subject: "Service Feedback",
  //     userType: "Customer",
  //     _id: 4,
  //   },
  //   {
  //     key: "5",
  //     name: "Eve White",
  //     email: "eve.white@example.com",
  //     datePosted: "2023-04-25",
  //     subject: "Driver Feedback",
  //     userType: "Driver",
  //     _id: 5,
  //   },
  // ];
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });
    getUsers(pageNumber, paginationConfig.limit);
  };
  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };
  const data = {
    status: filter.status,
    keyword: filter.keyword,
    from: filter.from,
    to: filter.to,
  };
  const handleApply = () => {
    let from;
    let to;
    if (data.from) {
      from = moment(filter?.from?.$d).format("YYYY-MM-DD");
    }
    if (data.to) {
      to = moment(filter?.to?.$d).format("YYYY-MM-DD");
    }
    if (from || to) {
      getUsers(paginationConfig.pageNumber, paginationConfig.limit, from, to);
    } else {
      return;
    }
  };
  const handleSearch = useDebouncedCallback((value) => {
    setFilter({
      ...filter,
      keyword: value,
    });
    getUsers(
      paginationConfig.pageNumber,
      paginationConfig.limit,
      null,
      null,
      value
    );
  }, 1000);
  const resetFilter = () => {
    setFilter({
      status: null,
      keyword: "",
      from: null,
      to: null,
    });
  };
  const handleClear = () => {
    resetFilter();
    getUsers();
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="pagination-link">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="pagination-link">
          Next
        </button>
      );
    }

    return originalElement;
  };
  const filterContent = (
    <div className="filterDropdown">
      <div>
        <p
          className="mainLabel"
          style={{ padding: "10px", fontSize: "18px", fontWeight: "bold" }}
        >
          Filter
        </p>
      </div>
      <hr style={{ marginBottom: 10 }} />

      <div className="filterDropdownBody">
        <p className="mainLabel">From:</p>
        <DatePicker
          className="mainInput filterInput web-input"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
          style={{ width: "100%" }}
        />
        <p className="mainLabel">To:</p>
        <DatePicker
          className="mainInput filterInput web-input"
          value={filter.to}
          onChange={(e) => handleTo(e)}
          style={{ width: "100%" }}
        />
        <Button
          type=""
          block
          size={"large"}
          style={{ marginBottom: "10px" }}
          className="web-btn"
          //   onClick={() => getUsers()}
          onClick={handleApply}
        >
          Apply
        </Button>
        <Button
          type=""
          block
          size={"large"}
          className="web-btn"
          onClick={handleClear}
        >
          Clear All
        </Button>
      </div>
    </div>
  );
  const columns = [
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          S.NO
        </p>
      ),
      dataIndex: "key",
      key: "key",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {(index < 10 && "0") + (index + 1)}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Name
        </p>
      ),
      dataIndex: "name",
      key: "name",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item?.firstName} {item?.lastName}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Email
        </p>
      ),
      dataIndex: "email",
      key: "email",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item.email}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Date Posted
        </p>
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (item) => <span>{dayjs.tz(item, "UTC").format("M/D/YYYY")}</span>,
    },

    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Pick Up Date
        </p>
      ),
      dataIndex: "pickUpDate",
      key: "pickUpDate",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {value ? dayjs.tz(value, "UTC").format("M/D/YYYY") : "-"}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Vehicle Category
        </p>
      ),
      dataIndex: "vehicleCategory",
      key: "vehicleCategory",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {value || "-"}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          action
        </p>
      ),
      dataIndex: "_id",
      key: "_id",
      render: (value, item, index) => (
        <div className="flex justify-center">
          <div className="flex justify-center bg-[#FDE6C3] rounded-[100%] w-fit p-2 mr-1">
            <FaEye
              className="text-[#CD810D] cursor-pointer h-[16px] w-[16px]"
              onClick={() =>
                navigate("/bookingRequestDetails/" + item._id, {
                  state: { feedback: item },
                })
              }
            />
          </div>
        </div>
      ),
    },
  ];
  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div className="flex max-md:flex-col max-md:items-start justify-between items-center my-8">
          <h3 className="font-tavi laptop:text-3xl text-xl font-normal text-black md:ml-8 max-md:mb-2">
            Booking Request Management
          </h3>
          <div className="flex justify-center items-center max-md:w-full max-md:justify-end">
            <Input
              className="mainInput dashInput h-full w-[250px] max-md:max-w-[150px]"
              placeholder="Search"
              onChange={(e) => handleSearch(e.target.value)}
              suffix={
                <FaSearch
                  style={{
                    color: "#818181",
                    fontSize: 16,
                    cursor: "pointer",
                  }}
                  //   onClick={() =>
                  //     getUsers(1, paginationConfig.limit, filter.keyword)
                  //   }
                />
              }
              //   onPressEnter={(e) =>
              //     getUsers(1, paginationConfig.limit, filter.keyword)
              //   }
            />
            &emsp;
            <div className="flex justify-center">
              <Popover
                content={filterContent}
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
                placement="bottomRight"
                arrow={false}
              >
                <Button
                  style={{
                    padding: "4px 11px",
                    height: "auto",
                    borderRadius: "6px",
                    backgroundColor: "white",
                  }}
                >
                  <MdTune className="text-[32px] text-[#767676]" />
                </Button>
              </Popover>
            </div>
          </div>
        </div>
        <div
          className="bg-white rounded-lg  py-8 my-8"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <Row style={{ overflow: "auto" }} className="px-6">
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Skeleton active />
                <br />
              </div>
            ) : (
              <Table
                className="styledTable"
                dataSource={feedbacks}
                columns={columns}
                pagination={false}
              />
            )}
          </Row>
          <Row style={{ padding: "10px 20px" }}>
            <Col xs={24} md={12}>
              <p className="font-euclid text-sm text-black">{message}</p>
            </Col>
            <Col
              xs={24}
              md={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Pagination
                className="styledPagination"
                onChange={(e) => handlePageChange(e)}
                current={parseInt(paginationConfig.pageNumber)}
                pageSize={paginationConfig.limit}
                total={paginationConfig.totalDocs}
                itemRender={itemRender}
              />
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default FeedbackManagement;
